import type { OnInit } from '@angular/core';
import { Component, Inject, Input } from '@angular/core';
import { Offer } from '@innogy/become-a-customer/shared/interfaces';
import { EnergyType } from '@essent/new-customer';
import { getYearlyCostsLabel } from '@innogy/become-a-customer/shared';
import { ENVIRONMENT_CONFIG } from '@core/config-angular';
import type { EnvConfigBrand } from '@core/config-models';
import { EnvironmentConfig } from '@core/config-models';

import { CommodityOfferLabels } from '../../../commodity-offers.model';
import { CommodityOfferEssentProductBreakdownRowComponent } from '../commodity-product-breakdown-row/commodity-product-breakdown-row.component';
import { SMECommodityOfferEssentProductBreakdownRowComponent } from '../sme-commodity-product-breakdown-row/sme-commodity-product-breakdown-row.component';
import { CommonModule } from '@angular/common';
import { ToolTipComponent } from '@legacy/common-ui-utility-components';

@Component({
  selector: 'essent-sme-commodity-product-breakdown',
  templateUrl: './sme-commodity-product-breakdown.component.html',
  styleUrls: ['./sme-commodity-product-breakdown.component.essent.scss'],
  standalone: true,
  imports: [
    CommodityOfferEssentProductBreakdownRowComponent,
    SMECommodityOfferEssentProductBreakdownRowComponent,
    CommonModule,
    ToolTipComponent,
  ],
})
export class SMECommodityOfferEssentProductBreakdownComponent
  implements OnInit
{
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() offer?: Offer;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() content?: CommodityOfferLabels;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() showMemberGetMember = false;
  public energyType = EnergyType;

  brand?: EnvConfigBrand;

  constructor(
    @Inject(ENVIRONMENT_CONFIG) private readonly envConfig: EnvironmentConfig
  ) {}

  ngOnInit() {
    this.brand = this.envConfig.brand;
  }

  selectCommodity(offer: Offer, energyType: EnergyType) {
    return offer.offerOverviews.find(
      (offerOverview) => offerOverview.energyType === energyType
    );
  }

  yearlyCostsLabel(offer: Offer) {
    return getYearlyCostsLabel(
      this.content?.yearlyCostsTotalDynamicWithIncentiveLabel ?? '',
      this.content?.yearlyCostsTotalDynamicWithoutIncentiveLabel ?? '',
      this.content?.yearlyCostsTotalWithIncentiveLabel ?? '',
      this.content?.yearlyCostsTotalWithoutIncentiveLabel ?? '',
      this.content?.yearlyCostsTotalMultiYearWithIncentiveLabel ?? '',
      this.content?.yearlyCostsTotalMultiYearWithoutIncentiveLabel ?? '',
      offer
    );
  }
}
